@if (traceId) {
  <div class="trace-badge">
    <span class="trace-id">{{ traceId }}</span>
    <button mat-icon-button (click)="copyTraceId()" aria-label="copy trace ID" class="copy-button">
      <mat-icon>content_copy</mat-icon>
    </button>
  </div>
}
